import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'

import injectRole from '../../components/HOC/injectRole'
import { TRoles, TRoutes } from '../../shared/const'

import CourseList from '../../components/views/common/Courses/CourseList'
import CourseHome from '../../components/views/common/Courses/CourseHome'
import LessonPlayer from '../../components/views/common/Courses/LessonPlayer'
import ModuleQuiz from '../../components/views/common/Courses/ModuleQuiz'
import TeacherCourses from '../../components/views/teacher/Courses'

/*
 * Kurse: Schüler:innen lernen, Lehrkräfte und Verwaltung sehen eine Vorschau.
 * Was jemand sehen und speichern darf, entscheidet der Server (`mode`);
 * hier wird nur ausgesperrt, wer mit Kursen nichts zu tun hat
 * (Unterstützer:innen, Alumni).
 */
const DARF = [TRoles.STUDENT, TRoles.TEACHER, TRoles.ADMIN, TRoles.FEDERAL_ADMIN]

const nurMit = Ansicht => {
	function Seite(props) {
		if (!DARF.includes(props.role)) return <Redirect to={TRoutes.DASHBOARD} />
		return <Ansicht />
	}
	Seite.propTypes = { role: PropTypes.string.isRequired }
	return injectRole(Seite)
}

/** `/kurse` — die Lehrkraft bekommt hier den Stand ihrer Junior Companies. */
function CoursesStart(props) {
	if (props.role === TRoles.TEACHER) return <TeacherCourses />
	if (!DARF.includes(props.role)) return <Redirect to={TRoutes.DASHBOARD} />
	return <CourseList />
}

CoursesStart.propTypes = { role: PropTypes.string.isRequired }

export const CoursesPage = injectRole(CoursesStart)
export const CoursePage = nurMit(CourseHome)
export const CourseLessonPage = nurMit(LessonPlayer)
export const CourseQuizPage = nurMit(ModuleQuiz)
